import { z } from 'zod';
import { Conversation } from '../client';
import { makeEvent } from './EventBase';

export const ConversationUpdated = makeEvent(
    'Conversation\\ConversationUpdated',
    z.object({
        data: Conversation,
    }),
);

export type ConversationUpdated = (typeof ConversationUpdated)['schema']['_output'];
